import script from "./PrivacyPolicyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPolicyPage.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=4955402d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4955402d"]])

export default __exports__